import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;
    public tab: string = 'stats';  // stats, profile, password

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    // 학습 통계
    public stats: any = {};
    public recentResults: any[] = [];
    public subjectStats: any[] = [];
    public loadingStats: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.loadStats();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
        }
        await this.service.render();
    }

    public async loadStats() {
        this.loadingStats = true;
        await this.service.render();

        const res = await wiz.call("stats");
        if (res.code === 200) {
            this.stats = res.data;
            this.recentResults = res.data.recent_results || [];
            this.subjectStats = res.data.subject_stats || [];
        }

        this.loadingStats = false;
        await this.service.render();
    }

    public async setTab(t: string) {
        this.tab = t;
        await this.service.render();
    }

    public getGradeColor(grade: number): string {
        if (grade <= 2) return 'text-blue-600';
        if (grade <= 4) return 'text-green-600';
        if (grade <= 6) return 'text-yellow-600';
        return 'text-red-500';
    }

    public getGradeBgColor(grade: number): string {
        if (grade <= 2) return 'bg-blue-100';
        if (grade <= 4) return 'bg-green-100';
        if (grade <= 6) return 'bg-yellow-100';
        return 'bg-red-100';
    }

    public viewResult(examId: string) {
        this.service.href(`/quiz/result/${examId}`);
    }

    public async updateProfile() {
        if (!this.user.name) {
            await this.service.alert.show({ title: '알림', message: '이름을 입력해주세요.' });
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("update_profile", {
            name: this.user.name,
            mobile: this.user.mobile || ''
        });

        this.saving = false;

        if (code === 200) {
            await this.service.alert.show({ title: '완료', message: '프로필이 업데이트되었습니다.' });
        } else {
            await this.service.alert.show({ title: '오류', message: data?.message || '업데이트에 실패했습니다.' });
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.alert.show({ title: '알림', message: '현재 비밀번호를 입력해주세요.' });
            return;
        }
        if (!new_password) {
            await this.service.alert.show({ title: '알림', message: '새 비밀번호를 입력해주세요.' });
            return;
        }
        if (new_password.length < 8) {
            await this.service.alert.show({ title: '알림', message: '새 비밀번호는 8자 이상이어야 합니다.' });
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.alert.show({ title: '알림', message: '새 비밀번호가 일치하지 않습니다.' });
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call("change_password", {
            current_password: current_password,
            new_password: new_password
        });

        this.changingPassword = false;

        if (code === 200) {
            await this.service.alert.show({ title: '완료', message: '비밀번호가 변경되었습니다.' });
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            await this.service.alert.show({ title: '오류', message: data?.message || '비밀번호 변경에 실패했습니다.' });
        }
        await this.service.render();
    }
}

export default PageMypageComponent;